import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';

import EmailInput from '../Enter/fields/EmailInput';
import SubmitButton from '../Enter/fields/SubmitButton';
import Spacer from '../common/Spacer';

import { validateEmail } from '../../utils/validation';
import { http } from '../../utils/http';
import useQuery from '../../utils/useQuery';
import { genericErrorMessage } from '../../utils/lang/commonErrors';

import styles from './RestorePasswordForm.scss';

const RestorePasswordForm = () => {
  const history = useHistory();
  const { email } = useQuery();

  const [emailValue, setEmailValue] = useState(email || '');
  const onEmailChange = (e) => setEmailValue(e.target.value);

  const [isLoading, setLoading] = useState(false);

  const [formErrors, setFormErrors] = useState({});

  const intl = useIntl();

  const onSubmit = () => {
    setLoading(true);
    const emailError = validateEmail(emailValue);

    if (!emailError) {
      http('/v1/account/reset-password', 'POST', {
        email: emailValue
      })
        .then(() => {
          history.push('/enter/password/restore/sent');
        }, (e) => {
          console.log(e);

          if (e.code === 5) {
            setFormErrors({
              email: intl.formatMessage({
                id: 'restorePassword.error.userDoesNotExist',
                defaultMessage: 'There is no such user',
                description: 'Error shown to user, after an attempt to reset password for an unexisting user'
              })
            });
          } else {
            setFormErrors({
              email: intl.formatMessage(genericErrorMessage)
            });
          }

          setLoading(false);
        });
    } else {
      setFormErrors({
        email: emailError
      });
      setLoading(false);
    }
  };

  return (
    <form className={styles.form}>
      <h2 className={styles.title}>
        <FormattedMessage
          id="restorePassword.title"
          defaultMessage="Restore password"
          description="Title of the password restore page"
        />
      </h2>
      <p className={styles.subtitle}>
        <FormattedMessage
          id="restorePassword.subtitle"
          defaultMessage="You will receive an email with restore link"
          description="Subtitle of the password restore page"
        />
      </p>

      <EmailInput value={emailValue} onChange={onEmailChange} error={formErrors.email} />

      <Spacer height={10} />

      <SubmitButton
        text={intl.formatMessage({
          id: 'restorePassword.submit',
          defaultMessage: 'Send me link',
          description: 'Submit button of the password restore form'
        })}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </form>
  );
};

export default RestorePasswordForm;
